// So far these are the pagetypes that use this component

import type { PageType } from '@susu/headless-commerce/types/PageType'

// Keep adding as new pagetypes implememnt it
export const listNameMap: Partial<Record<PageType, string>> = {
  category: 'category page landing',
  category_landing: 'category page landing',
  journal: 'Journal',
}

export const fallbackListName = 'PAGET_TYPE_UNDEFINED-PLEASE_FIX'
